import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import { bibShape, shelfItemShape, ugcAgeSuitabilityShape } from '@bibliocommons/bc-prop-types';
import { Dropdown } from '@bibliocommons/deprecated-base-dropdown';

import BaseUGCEditor from '../BaseUGCEditor';

import './AgeSuitabilityUGCEditor.scss';

const MAX_AGE = 21;

export class AgeSuitabilityUGCEditor extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    const { existingAgeSuitability } = this.props;
    this.state = {
      age: existingAgeSuitability ? existingAgeSuitability.get('min') : -1
    };
  }

  getAgeOptions() {
    const ageOpts = Array(MAX_AGE)
      .fill()
      .map((_, age) => ({
        key: `age-suitability-dropdown-${age + 1}`,
        value: age + 1,
        label: this.props.intl.formatMessage({ id: 'ugc_age_suitability_ages' }, { age: age + 1, plus: '+' })
      }));

    return [
      {
        key: null,
        value: null,
        label: this.props.intl.formatMessage({
          id: 'ugc_age_suitability_age_all'
        })
      }
    ].concat(ageOpts);
  }

  getSelectedAge() {
    const { age } = this.state;
    let ageSelected = '';

    if (age > 0) {
      ageSelected = this.props.intl.formatMessage({ id: 'ugc_age_suitability_ages' }, { age, plus: '+' });
    } else if (age === -1) {
      ageSelected = this.props.intl.formatMessage({
        id: 'age_suitability_dropdown_placeholder'
      });
    }
    return ageSelected || this.props.intl.formatMessage({ id: 'ugc_age_suitability_age_all' });
  }

  handleSave(callback) {
    const { bib, existingAgeSuitability, ageSuitabilitiesActions } = this.props;
    const age = this.state.age;
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const ageSuitabilityId = existingAgeSuitability && existingAgeSuitability.get('id');
    const postSuccess = callback;

    if (ageSuitabilityId) {
      ageSuitabilitiesActions.updateAgeSuitability({
        min: age,
        metadataId,
        ageSuitabilityId,
        postSuccess
      });
    } else {
      ageSuitabilitiesActions.addAgeSuitability({
        metadataId,
        min: age,
        postSuccess
      });
    }
  }

  handleSelect(age) {
    this.setState({ age });
  }

  renderHeader() {
    const { existingAgeSuitability } = this.props;
    const ageSuitabilityId = existingAgeSuitability && existingAgeSuitability.get('id');

    return (
      <h2>
        {ageSuitabilityId ? (
          <FormattedMessage id="edit_age_suitability" />
        ) : (
          <FormattedMessage id="add_age_suitability" />
        )}
      </h2>
    );
  }

  renderAgeDropdownOption() {
    return (
      <div className="age-suitability-editor-dropdown">
        <label id="age-suitability-dropdown-label" htmlFor="age-suitability-dropdown">
          <FormattedMessage id="age_suitability_dropdown_label" />
        </label>
        <Dropdown
          className="btn-default btn-flat"
          dataKey="age-suitability-ugc-editor-dropdown"
          defaultValue={this.props.intl.formatMessage({
            id: 'age_suitability_dropdown_placeholder'
          })}
          selected={this.getSelectedAge()}
          labelledById="age-suitability-dropdown-label"
          options={this.getAgeOptions()}
          handleSelect={this.handleSelect}
        />
      </div>
    );
  }

  render() {
    const {
      bib,
      existingAgeSuitability,
      ageSuitabilitiesTransactions,
      shelfItem,
      shelfActions,
      shelfTransactions,
      handleClose
    } = this.props;
    const ageSuitabilityId = existingAgeSuitability && existingAgeSuitability.get('id');
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const isSavingAgeSuitability = ageSuitabilityId
      ? ageSuitabilitiesTransactions.getIn([metadataId, ageSuitabilityId, 'isUpdating'], false)
      : ageSuitabilitiesTransactions.getIn([metadataId, 'isAdding'], false);

    return (
      <div>
        <BaseUGCEditor
          bib={bib}
          showPrivacyAlert
          className="cp-age-suitability-ugc-editor"
          renderHeader={this.renderHeader}
          handleSave={this.handleSave}
          handleClose={handleClose}
          isSaving={isSavingAgeSuitability}
          saveButtonDisabled={this.state.age === -1}
          shelfItem={shelfItem}
          shelfTransactions={shelfTransactions}
          shelfActions={shelfActions}
        >
          <p className="age-suitability-info">
            <FormattedMessage id="age_suitability_info" />
          </p>
          {this.renderAgeDropdownOption()}
        </BaseUGCEditor>
      </div>
    );
  }
}

const injectIntlPropTypes = {};

AgeSuitabilityUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  existingAgeSuitability: ugcAgeSuitabilityShape,
  shelfItem: shelfItemShape,
  handleClose: PropTypes.func.isRequired,
  ageSuitabilitiesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ageSuitabilitiesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ...injectIntlPropTypes
};

export default injectIntl(AgeSuitabilityUGCEditor);
